import { api } from "convex/_generated/api";
import { useWorkspaceQuery } from "@/hooks";
import type { Id } from "@/packages/types";

export interface AuditTemplate {
  id: Id<"auditTemplates">;
  name: string;
  description: string | undefined;
  code: string;
}

interface UseAuditTemplatesReturn {
  templates: AuditTemplate[] | undefined;
  isLoading: boolean;
}

export function useAuditTemplates(): UseAuditTemplatesReturn {
  const { data, isLoading } = useWorkspaceQuery(
    api.audit_queries.getAuditTemplates,
    {},
  );

  const templates = data?.map((t) => ({
    id: t._id,
    name: t.displayName,
    description: t.description,
    code: t.code,
  }));

  return { templates, isLoading };
}
